const home = {
  "nav.home": "Início",
  "nav.categories": "Categorias",
  "nav.guide": "Guia de Compras",
  "nav.about": "Sobre",
  "nav.faq": "FAQ",
  "nav.contact": "Contato",
  "hero.h1_line1": "Planilha Hoobuy 2026",
  "hero.h1_line2": "O Maior Hoobuy Spreadsheet",
  "hero.h1_line3": "em Português",
  "hero.subtitle": "Descubra milhares de produtos verificados no Hoobuy Spreadsheet. Tênis, roupas, streetwear, acessórios e links atualizados diariamente.",
  "hero.cta_sheet": "Acessar Hoobuy Sheet",
  "hero.cta_buy": "Buy It Now",
  "hero.cta_products": "Ver Produtos Mais Vendidos",
  "trust.title_line1": "Por que Escolher",
  "trust.title_line2": "o Hoobuy Sheet?",
  "trust.stat1_number": "10.000+",
  "trust.stat1_label": "Produtos Verificados",
  "trust.stat2_number": "Diária",
  "trust.stat2_label": "Atualização de Links",
  "trust.stat3_number": "100%",
  "trust.stat3_label": "Guias em Português",
  "trust.stat4_number": "5 Anos",
  "trust.stat4_label": "Experiência no Mercado",
  "trust.stat5_number": "Manual",
  "trust.stat5_label": "Verificação de Qualidade",
  "categories.title_line1": "Navegue por",
  "categories.title_line2": "Categoria",
  "categories.subtitle": "Encontre exatamente o que procura em nossa planilha organizada com milhares de links verificados.",
  "categories.all": "Ver Todas as Categorias",
  "features.tag": "POR QUE SOMOS DIFERENTES",
  "features.title_line1": "Economize Tempo,",
  "features.title_line2": "Compre com Segurança",
  "features.f1_title": "Atualização Diária",
  "features.f1_desc": "Nossa equipe verifica e atualiza todos os links diariamente. Você nunca encontrará produtos esgotados ou links quebrados na planilha Hoobuy.",
  "features.f2_title": "Links Diretos",
  "features.f2_desc": "Cada produto na planilha tem link direto para compra. Sem intermediários, sem complicação — encontre e compre em segundos.",
  "features.f3_title": "Verificação Manual",
  "features.f3_desc": "Não usamos bots. Cada link é verificado manualmente pela nossa equipe para garantir qualidade e segurança para você.",
  "testimonials.tag": "O QUE DIZEM",
  "testimonials.title_line1": "Usuários Reais,",
  "testimonials.title_line2": "Resultados Reais",
  "testimonials.subtitle": "Milhares de brasileiros e portugueses já confiam na nossa planilha.",
  "footer.brand_tagline": "O recurso número um em português para produtos Hoobuy verificados. Links atualizados, guias completos e suporte dedicado.",
  "footer.newsletter_title": "Receba Atualizações",
  "footer.newsletter_placeholder": "Seu melhor email",
  "footer.newsletter_button": "Inscrever",
  "footer.newsletter_success": "Inscrição confirmada! Verifique seu email.",
  "footer.newsletter_error": "Erro ao inscrever. Tente novamente.",
  "footer.column1_title": "Navegação",
  "footer.link_home": "Início",
  "footer.link_categories": "Categorias",
  "footer.link_about": "Sobre Nós",
  "footer.link_faq": "FAQ",
  "footer.column2_title": "Categorias",
  "footer.column3_title": "Recursos",
  "footer.link_blog": "Artigos",
  "footer.link_safety": "É Seguro?",
  "footer.link_shipping": "Envios",
  "footer.link_contact": "Contato",
  "footer.column4_title": "Principais Links",
  "footer.copyright": "© 2026 Hoobuy Lifestyle. Todos os direitos reservados.",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",
  "cta_split.tag": "Links Verificados 2026",
  "cta_split.title_line1": "Pronto para",
  "cta_split.title_line2": "Começar?",
  "cta_split.title_line3": "Buy It Now",
  "cta_split.desc": "Acesse agora a planilha mais completa de produtos Hoobuy. Milhares de itens verificados, preços atualizados e links diretos para você comprar com total segurança.",
  "cta_split.button": "Acessar Agora",
  "article.back_home": "← Voltar ao Início",
  "article.author": "Equipe Hoobuy Lifestyle",
  "article.updated": "Atualizado em Junho 2026",
  "article.reviewed": "Conteúdo revisado e verificado.",
  "article.related": "Artigos Relacionados",
  "article.read_more": "Ler Mais",
};

export default home;